/* eslint-disable @typescript-eslint/ban-ts-comment */
import { BrowserRouter } from 'react-router-dom';
import Router from './components/Router';
import './styles/main.scss';
import { Box, ThemeProvider } from '@ace-clublabs/shared-component-library';
import LogCannon from '@ace-clublabs/log-cannon';
import { TeamValue, WorkloadValue } from '@ace-clublabs/aws-tags';
import { version } from 'process';
import { useEffect, useState } from 'react';
import { useGlobalState } from './shared/state';
import { Environments, getEnvironmentFromHost } from './api/endpoints';
import Cookies from 'universal-cookie';
import { IS_MOBILE_APP } from './constants';

const cookies = new Cookies();

export const App = () => {
  window.global ||= window;
  const base_url = '/payments';
  const [, setIsMobileApp] = useGlobalState('isMobileApp');
  const [, setSessionId] = useGlobalState('sessionId');
  const [hasMobileAppCookie] = useState(cookies.get(IS_MOBILE_APP));

  const apiKey = import.meta.env.VITE_LOGCANNON_API_KEY;

  LogCannon.init(apiKey, {
    team: TeamValue.Payments,
    component: 'payments',
    //@ts-ignore
    workload: WorkloadValue.Payments,
    runtime: 'nodejs',
    runtimeVersion: version,
  });

  useEffect(() => {
    const sessionId = LogCannon.getSessionId();
    setSessionId(sessionId);

    const urlParams = new URLSearchParams(window.location.search);
    const isMobileApp = urlParams.get('mobileapp') === 'true' || hasMobileAppCookie || false;
    setIsMobileApp(isMobileApp);

    const env = getEnvironmentFromHost(window.location.hostname) === Environments.prod ? 'prod' : 'uat';
    if ((global as any).firstDataLoadAttempt) return;
    (global as any).firstDataLoadAttempt = true;
    const firstDataJsScript = document.createElement('script');
    firstDataJsScript.src = `//lib.paymentjs.firstdata.com/${env}/client-2.0.0.js`;
    firstDataJsScript.type = 'text/javascript';
    firstDataJsScript.async = true;
    document.body.appendChild(firstDataJsScript);
  }, []);

  return (
    <BrowserRouter basename={base_url}>
      <ThemeProvider>
        <Box className="container">
          <Router />
        </Box>
      </ThemeProvider>
    </BrowserRouter>
  );
};

export default App;
